export default "__VITE_ASSET__CbRECzEA__"